import React, { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import s from './WordList.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import {modifiedDate} from '../middleware/dateControl';
import {getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import { useOutletContext } from "react-router-dom";
import {SoundPlayer} from'./Utilities/SoundPlayer.js';
import {GreenButton} from './MyButton';

import uploadPng from'../asset/upload.png';
import dicePng from'../asset/dice.png';
import speakRerollPng from'../asset/speakReroll.png';
import examplePng from'../asset/example.png';

const FormatMeaningQtn = ({format, data, setData, inputValue, setInputValue, createWordQtn, isFetchingData}) => {
	const navigate = useNavigate();
	const rerollMeaningQtn = async (w, indexD) => {
		data[indexD].rerollingMeaningQtn = true;
		setData([...data])
		
		let obj = { qId: w.qId, wId: w.wordId, word: w.word }
		
		let res;
		if (format == 'qmeaning') {
			res = await postData("wordApi/rerollMeaningQtn", obj, navigate)
		} else {
			res = await postData("wordApi/rerollMeaningQtnHk", obj, navigate)
		}
		
		
		let answer = res.data.answer;
		let option1 = res.data.option1;
		let option2 = res.data.option2;
		let option3 = res.data.option3;
		
		data[indexD].answer = answer;
		data[indexD].option1 = option1;
		data[indexD].option2 = option2;
		data[indexD].option3 = option3;
		data[indexD].rerollingMeaningQtn = false;
		setData([...data])
		
		inputValue[w.wordId.toString()] = w;
		inputValue[w.wordId.toString()].answer = answer;
		inputValue[w.wordId.toString()].option1 = option1;
		inputValue[w.wordId.toString()].option2 = option2;
		inputValue[w.wordId.toString()].option3 = option3;
		
		setInputValue({...inputValue});
	}
	
	const fillInAll = async () => {
		setIsFilling(true);
		for (const [index, d] of data.entries()){

			if (!d.qcType) {
				await createWordQtn(d.wordId, d.word)
			}
			
			if (!d.answer) {
				await rerollMeaningQtn(d, index)
			}
		}
		setIsFilling(false);
	}
	
	const [isFilling, setIsFilling] = useState(false);
	
	return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div className={s.triggerBatchBtn}>
				<GreenButton isEnabled={true} 
					clickedAction={fillInAll} bText={"Fill-in All"} 
					isLoading={isFilling}/>
			</div>
			<div style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", borderBottom:"1px solid #4b3f1b", color:"#75390b", alignItems:"flex-end"}}>
				<div className={s.tableHeader} style={{flex: '0 0 45px', letterSpacing:"-0.1rem"}}>Reroll</div>
				<div className={s.tableHeader} style={{flex: '0 0 40px', letterSpacing:"0.1rem"}}>Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 150px'}}>WORD</div>
				<div className={s.tableHeader} style={{flex: '0 0 295px'}}><span className={s.tableHeaderSpan}>ANSWER</span></div>
				<div className={s.tableHeader} style={{flex: '0 0 340px'}}>OPTION 1</div>
				<div className={s.tableHeader} style={{flex: '0 0 360px'}}>OPTION 2</div>
				<div className={s.tableHeader} style={{flex: '0 0 330px'}}>OPTION 3</div>
			</div>
			
			{(!isFetchingData) && (<>
			
		{
			data.map((d, indexD) => (<div key={'meaning-' + indexD}
				style={{display:"flex", flexWrap:"nowrap", margin:"0 30px"
				, alignItems:"center"
				, backgroundColor:(indexD%2==0) ? "white" : "#22222222"
				}}
				>
				
				{
					(!d.qcType) &&
					(<>
						<div className={s.wordTitleCreate} onClick={()=>createWordQtn(d.wordId, d.word)}>
							{d.word} 
							<span>click to create</span>
						</div>
					</>)
				}
				{
					(d.qcType) &&
					(<>
						
						<div className={s.diceIconHolder}
							onClick={()=>rerollMeaningQtn(d, indexD)}>
							<img className={s.diceIcon} src={dicePng} />
							{
								(d.rerollingMeaningQtn) && (<img className={s.diceIconRerolling} src={dicePng} />)
							}
						</div>
						<div className={s.wordId} style={{flex: '0 0 40px'}}>{d.wordId}</div>
					
						<div className={s.wordTitle} style={{flex: '0 0 150px'}}>{d.word}</div>
						<div className={s.growWrap} style={{flex: '0 0 300px'}} dataReplicatedValue={d.answer}>
						<textarea rows="1" value={d.answer} onChange={(e)=>{
							data[indexD].answer = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].answer = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} style={{flex: '0 0 340px'}} dataReplicatedValue={d.option1}>
						<textarea rows="1" value={d.option1} onChange={(e)=>{
							data[indexD].option1 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option1 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} style={{flex: '0 0 360px'}} dataReplicatedValue={d.option2}>
						<textarea rows="1" value={d.option2} onChange={(e)=>{
							data[indexD].option2 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option2 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} style={{flex: '0 0 330px'}} dataReplicatedValue={d.option3}>
						<textarea rows="1" value={d.option3} onChange={(e)=>{
							data[indexD].option3 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option3 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.wordMsgDate} >{modifiedDate(d.updateTs)} @ {d.username}</div></>)
				}
				
			</div>))
		}
	
			</>)}
	</div>);
}

const FormatBasic = ({itemId, format, data, setData, inputValue, setInputValue, isFetchingData}) => {
	const [showType, setShowType] = useState(getGeneralStorage('wordListShowType') ?? "basic");//basic, audio, example

	const navigate = useNavigate();
	const reroll = async (w, wordId, word, indexD, isStrongReroll = false) => {
		
		let obj = { wId:wordId, wordId, word }
		if (isStrongReroll) {
			obj.isStrongReroll = isStrongReroll;
		}
		
		if (showType == 'basic') {
			data[indexD].rerollingMeaning = true;
			setData([...data])
			
			let res = await postData("wordApi/rerollMeaning", obj, navigate)
			let en = res.data.en;
			let hk = res.data.hk;
			
			data[indexD].sMeaning = en;
			data[indexD].sMeaningHk = hk;
			data[indexD].rerollingMeaning = false;
			setData([...data])
			
			inputValue[w.wordId.toString()] = w;
			inputValue[w.wordId.toString()].sMeaning = en;
			inputValue[w.wordId.toString()].sMeaningHk = hk;
			setInputValue({...inputValue});
		} else if (showType == 'audio') {
			data[indexD].rerollingAudio = true;
			setData([...data])
			
			let res = await postData("wordApi/loadAudioIpa", obj, navigate)
			
			data[indexD].ipa = res.data.ipa;
			data[indexD].audioSound = res.data.audioSound;
			data[indexD].rerollingAudio = false;
			setData([...data])
			
			/*inputValue[w.wordId.toString()] = w;
			inputValue[w.wordId.toString()].ipa = ipa;
			inputValue[w.wordId.toString()].audioSound = audioSound;
			setInputValue({...inputValue});
			*/
		
		} else if (showType == 'example') {
			if (itemId) {
				obj['itemId'] = itemId;
			}
			data[indexD].rerollingExample = true;
			setData([...data])
			
			let res = await postData("wordApi/loadExamples", obj, navigate)
			
			for (let i = 0; i < res.data.length; i++) {
				let d = res.data[i];
				
				if (!data[indexD].exampleJson[i]) {
					data[indexD].exampleJson[i] = {};
				}
				
				
				data[indexD].exampleJson[i].en = d.en;
				data[indexD].exampleJson[i].hk = d.hk;
				data[indexD].exampleJson[i].audioPath = d.audioPath;
			}
			
			data[indexD].rerollingExample = false;
			setData([...data])
		}
	}
	
	const [isFilling, setIsFilling] = useState(false);
	const tranHk = async (w, indexD, i) => {
		data[indexD].exampleJson[i].tranHkLoading = true;
		setData([...data])
		
		let obj = { sentence:data[indexD].exampleJson[i].en }
		let res = await postData("utility/translateSentence", obj, navigate); 
		
		obj = { wId:w.wordId, index:i, hk:res.data};
		postData("wordApi/updateExampleJson", obj, navigate);
		
		data[indexD].exampleJson[i].hk = res.data;
		data[indexD].exampleJson[i].tranHkLoading = false;
		setData([...data])
	}
	
	const genAudio = async (w, indexD, i) => {
		data[indexD].exampleJson[i].genAudioLoading = true;
		setData([...data])
		
		let obj = { sentence:data[indexD].exampleJson[i].en }
		let res = await postData("utility/getSentenceAudio", obj, navigate); 
		let soundTrack = res.data;
				
		obj = { wId:w.wordId, index:i, audioPath:soundTrack};
		postData("wordApi/updateExampleJson", obj, navigate);
		
		data[indexD].exampleJson[i].audioPath = soundTrack;
		data[indexD].exampleJson[i].genAudioLoading = false;
		setData([...data])
	}
	
	const changeType = async () => {
		switch(showType) {
			case 'basic':
				setShowType('audio'); 
				setGeneralStorage('wordListShowType', 'audio');
				break;
			case 'audio':
				setShowType('example'); 
				setGeneralStorage('wordListShowType', 'example');
				break;
			case 'example':
				setShowType('basic'); 
				setGeneralStorage('wordListShowType', 'basic');
				break;
		}
	}
	
	const fillInAll = async () => {
		setIsFilling(true);
		if (showType == 'basic') {
			for (const [index, d] of data.entries()){
				if (!d.sMeaningHk) {
					await reroll(d, d.wordId, d.word, index)
				}
				//await new Promise((resolve) => setTimeout(resolve, 1000));
			}
		} else if (showType == 'audio') {
			
			for (const [index, d] of data.entries()){
				if (!data[index].audioSound) {					
					let obj = { wordId: d.wordId, word: d.word }
					
					data[index].rerollingAudio = true;
					setData([...data])
					
					let res = await postData("wordApi/loadAudioIpa", obj, navigate)
					
					data[index].ipa = res.data.ipa;
					data[index].audioSound = res.data.audioSound;
					data[index].rerollingAudio = false;
					setData([...data])
					
					//await new Promise((resolve) => setTimeout(resolve, 1000));
				}
			}
		} else if (showType == 'example') {
			for (const [index, d] of data.entries()){
				if (!data[index].exampleJson[0].en) {		
					await reroll(d, d.wordId, d.word, index, true)
				} else {
					if (data[index].exampleJson[0].en) {
						if (!data[index].exampleJson[0].hk) {
							tranHk(d, index, 0);
						}
						
						if (!data[index].exampleJson[0].audioPath) {
							genAudio(d, index, 0);
						}
					}				
					
					if (data[index].exampleJson[1].en) {
						if (!data[index].exampleJson[1].hk) {
							tranHk(d, index, 1);
						}
						
						if (!data[index].exampleJson[1].audioPath) {							
							genAudio(d, index, 1);
						}
					}
					
					if (data[index].exampleJson[2].en) {
						if (!data[index].exampleJson[2].hk) {
							tranHk(d, index, 2);
						}
						
						if (!data[index].exampleJson[2].audioPath) {
							genAudio(d, index, 2);
						}
					}
				}
			}
		}
		
		
		setIsFilling(false);
	}
	
	const updateIpa = async (d, indexD) => {
		let obj = { wordId : d.wordId, ipa : d.ipa }
		
		let res = await postData("wordApi/updateAudioIpa", obj, navigate)
		
		data[indexD].audioSound = res.data;
		setData([...data])
	}
	
	return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div className={s.triggerBatchBtn}>
				<GreenButton isEnabled={true} 
					clickedAction={fillInAll} bText={"Fill-in All"} 
					isLoading={isFilling}/>
			</div>
			<div style={{display:"flex"}}>
				<div className={s.showTypeBtn} onClick={changeType}>{showType}</div>
			</div>
			<div style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", borderBottom:"1px solid #4b3f1b", color:"#75390b", alignItems:"flex-end"}}>
				<div className={s.tableHeader} style={{flex: '0 0 45px', letterSpacing:"-0.1rem"}}>Reroll</div>
				<div className={s.tableHeader} style={{flex: '0 0 60px', letterSpacing:"0.1rem"}}>Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 150px'}}>WORD</div>
				
				{
					(showType == 'basic') && (<>
						<div className={s.tableHeader} style={{flex: '0 0 300px'}}>MEANING HK</div>
						<div className={s.tableHeader} style={{flex: '0 0 1000px'}}>MEANING</div>
					</>)
				}
				
				{
					(showType == 'audio') && (<>
						<div className={s.tableHeader} style={{flex: '0 0 40px'}}>audio</div>
						<div className={s.tableHeader} style={{flex: '0 0 200px'}}>IPA</div>
						<div className={s.tableHeader} style={{flex: '0 0 100px'}}></div>
					</>)
				}
				{
					(showType == 'example') && (<>
						<div className={s.tableHeader} style={{flex: '0 0 300px'}}>Ex 1</div>
						<div className={s.tableHeader} style={{flex: '0 0 300px'}}>Ex 2</div>
						<div className={s.tableHeader} style={{flex: '0 0 300px'}}>Ex 3</div>
					</>)
				}
				<div className={s.tableHeader} style={{flex: '0 0 100px'}}>Last Update</div>
			</div>
			
			
			{(!isFetchingData) && (<>
			
		{
			data.map((d, indexD) => (<div key={'basic-' + indexD}
				style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", alignItems:"center"
				, backgroundColor:(indexD%2==0) ? "white" : "#22222222"
				}}
				>
				
				
				{
				
					(showType == 'basic') && (<div className={s.diceIconHolder} style={{flex: '0 0 30px'}} onClick={()=>reroll(d, d.wordId, d.word, indexD)}>
						<img className={s.diceIcon} src={dicePng} />
						{
							(d.rerollingMeaning) && (<img className={s.diceIconRerolling} src={dicePng} />)
						}
					</div>)
				
				}
				{
				
					(showType == 'audio') && (<div className={s.diceIconHolder} style={{flex: '0 0 30px'}} onClick={()=>reroll(d, d.wordId, d.word, indexD)}>
						<img className={s.diceIcon} src={speakRerollPng} />
						{
							(d.rerollingAudio) && (<img className={s.diceIconRerolling} src={speakRerollPng} />)
						}
					</div>)
				
				}
				
				{
				
					(showType == 'example') && (<div className={s.diceIconHolder} style={{flex: '0 0 30px'}} onClick={()=>reroll(d, d.wordId, d.word, indexD, true)}>
						<img className={s.diceIcon} src={examplePng} />
						{
							(d.rerollingExample) && (<img className={s.diceIconRerolling} src={examplePng} />)
						}
					</div>)
				
				}
				
				
				<div className={s.wordId} style={{flex: '0 0 60px'}}>{d.wordId}</div>
				<div className={s.wordTitle} style={{flex: '0 0 150px'}}>{d.word}</div>
				
				{(showType == 'basic') && (<>
					<div className={s.growWrap} style={{flex: '0 0 300px'}} dataReplicatedValue={d.sMeaningHk}>
						<textarea rows="1" value={d.sMeaningHk} onChange={(e)=>{
							data[indexD].sMeaningHk = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].sMeaningHk = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} style={{flex: '0 0 1000px'}} dataReplicatedValue={d.sMeaning}>
						<textarea rows="1" value={d.sMeaning} onChange={(e)=>{
							data[indexD].sMeaning = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].sMeaning = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					</>)
				}
				
				{(showType == 'audio') && (<>
						<div className={s.growWrap} style={{margin: '0 10px', width:"25px",height:"25px", position:"relative"}} >
							<SoundPlayer soundFile={d.audioSound}/>
								
						</div>
						<div className={s.growWrap} style={{flex: '0 0 200px'}} dataReplicatedValue={d.ipa}>
							<textarea rows="1" value={d.ipa} onChange={(e)=>{
								data[indexD].ipa = e.target.value;
								setData([...data])
							}} />
						</div>
						<div className={s.growWrap} style={{flex: '0 0 100px', display:"flex", itemAligns:"center"}}>
							<div className={(d.ipa) ? s.updateBtn : s.noUpdateBtn}>
								<div onClick={()=>{
									if (d.ipa) {
										updateIpa(d, indexD)
									}
									}}>
									update
								</div>
							</div>
						</div>
					</>)
				}
				
				{(showType == 'example') && (<div style={{display:"flex", flexDirection:"column", flex: '0 0 1500px'}}>
						<div style={{display:"flex"}}>
							
							{(d.exampleJson[0]) &&
							(<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[0].en}>
								<textarea rows="1" value={d.exampleJson[0].en} onChange={(e)=>{
									data[indexD].exampleJson[0].en = e.target.value;
									setData([...data])
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[0].en = e.target.value;
									setInputValue({...inputValue});
								}} />
							</div>)}
							{(d.exampleJson[1]) &&
							(
							<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[1].en}>
								<textarea rows="1" value={d.exampleJson[1].en} onChange={(e)=>{
									data[indexD].exampleJson[1].en = e.target.value;
									setData([...data])
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[1].en = e.target.value;
									setInputValue({...inputValue});
								}} />
							</div>)}
							{(d.exampleJson[2]) &&
							(
							<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[2].en}>
								<textarea rows="1" value={d.exampleJson[2].en} onChange={(e)=>{
									data[indexD].exampleJson[2].en = e.target.value;
									setData([...data])			
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[2].en = e.target.value;						
									setInputValue({...inputValue});
								}} />
							</div>)}

						</div>
						
						<div style={{display:"flex"}}>

							
							{(d.exampleJson[0]) &&
							(<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[0].hk}>
								<textarea rows="1" value={d.exampleJson[0].hk} onChange={(e)=>{
									data[indexD].exampleJson[0].hk = e.target.value;
									setData([...data])
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[0].hk = e.target.value;		
									setInputValue({...inputValue});
								}} />
							</div>)}
							{(d.exampleJson[1]) &&
							(<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[1].hk}>
								<textarea rows="1" value={d.exampleJson[1].hk} onChange={(e)=>{
									data[indexD].exampleJson[1].hk = e.target.value;
									setData([...data])
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[1].hk = e.target.value;	
									setInputValue({...inputValue});
								}} />
							</div>)}
							{(d.exampleJson[2]) &&
							(<div className={s.growWrap} style={{flex: '0 0 500px'}} dataReplicatedValue={d.exampleJson[2].hk}>
								<textarea rows="1" value={d.exampleJson[2].hk} onChange={(e)=>{
									data[indexD].exampleJson[2].hk = e.target.value;
									setData([...data])
									
									inputValue[d.wordId.toString()] = d;
									inputValue[d.wordId.toString()].exampleJson = data[indexD].exampleJson;
									inputValue[d.wordId.toString()].exampleJson[2].hk = e.target.value;	
									setInputValue({...inputValue});
								}} />
							</div>)}

						</div>
						<div style={{display:"flex"}}>
							<div className={s.growWrap} style={{flex: '0 0 500px', display:"flex"}}>
							
							{(d.exampleJson[0]) && (<>
								<div className={s.growWrap} style={{margin: '0 auto 0 0', width:"25px",height:"25px", position:"relative"}} >
									<SoundPlayer soundFile={d.exampleJson[0].audioPath}/>
								</div>
								<div style={{marginRight:"10px"}}>
									<GreenButton isEnabled={(d.exampleJson[0].en)} 
										clickedAction={()=>tranHk(d, indexD, 0)} bText={"Tran HK"} 
										isLoading={d.exampleJson[0].tranHkLoading}/>
								</div>
								<div>
									<GreenButton isEnabled={(d.exampleJson[0].en)} 
									clickedAction={()=>genAudio(d, indexD, 0)} bText={"Gen Audio"} 
									isLoading={d.exampleJson[0].genAudioLoading} />
								</div>
							</>)}
								
							</div>
							<div className={s.growWrap} style={{flex: '0 0 500px', display:"flex"}}>
							
							
							{(d.exampleJson[1]) && (<>
								<div className={s.growWrap} style={{margin: '0 auto 0 0', width:"25px",height:"25px", position:"relative"}} >
									<SoundPlayer soundFile={d.exampleJson[1].audioPath}/>
								</div>
								<div style={{marginRight:"10px"}}>
									<GreenButton isEnabled={(d.exampleJson[1].en)} 
										clickedAction={()=>tranHk(d, indexD, 1)} bText={"Tran HK"} 
										isLoading={d.exampleJson[1].tranHkLoading}/>
								</div>
								<div>
									<GreenButton isEnabled={(d.exampleJson[1].en)} 
									clickedAction={()=>genAudio(d, indexD, 1)} bText={"Gen Audio"} 
									isLoading={d.exampleJson[1].genAudioLoading} />
								</div>
							</>)}
								
								
							</div>
							<div className={s.growWrap} style={{flex: '0 0 500px', display:"flex"}}>
							
							
							{(d.exampleJson[2]) && (<>
								<div className={s.growWrap} style={{margin: '0 auto 0 0', width:"25px",height:"25px", position:"relative"}} >
									<SoundPlayer soundFile={d.exampleJson[2].audioPath}/>
								</div>
								<div style={{marginRight:"10px"}}>
									<GreenButton isEnabled={(d.exampleJson[2].en)} 
										clickedAction={()=>tranHk(d, indexD, 2)} bText={"Tran HK"} 
										isLoading={d.exampleJson[2].tranHkLoading}/>
								</div>
								<div>
									<GreenButton isEnabled={(d.exampleJson[2].en)} 
									clickedAction={()=>genAudio(d, indexD, 2)} bText={"Gen Audio"} 
									isLoading={d.exampleJson[2].genAudioLoading} />
								</div>
							</>)}
								
								
							</div>

						</div>
						
					</div>)
				}
				<div className={s.wordMsgDate} style={{flex: '0 0 100px'}} >{modifiedDate(d.updateTs)} @ {d.username}</div>
			</div>))
		}
	
			</>)}
	</div>);
}

const PagePanel = ({totalCnt, page, choosePage, limit}) => {
	if (totalCnt == 0) {
		return (<div style={{padding:"0 15px",margin:"0 5px"}}><span>-</span></div>)
	}
	
	let totalPage = Math.ceil(totalCnt / limit);
	
	return (<div style={{padding:"0",margin:"0", display:"flex", flexWrap:"wrap"}}>
		{
			Array.from({ length: totalPage }, (_, index) => (
				<div className={s.clickableOption + ' ' + s.pagePanelBtn}
					style={(page == (index+1)) ? {background:"#ebccad"} : {}} key={index}
					onClick={() => {
						
						if (index+1 != page) {
							choosePage(index+1)
						}
					}}					
					>
					{index + 1}
				</div>
			))
		}
	</div>);
}

export default function WordList(props) {
	const navigate = useNavigate();
	const [logger] = useOutletContext();
	
	let setParamCall = props.setParamCall;
	
	let showItemSearch = props.showItemSearch ?? true;
	
	const [target, setTarget] = useState(props.target ?? "dse-excellence");
	const [format, setFormat] = useState(props.format ?? "qmeaning");
	const [page, setPage] = useState(props.page ?? 1);
	const [limit, setLimit] = useState(props.limit ?? 100);
	const [itemId, setItemId] = useState(props.itemId ?? null);
	const [orderBy, setOrderBy] = useState(props.orderBy ?? "alphabet"); //alphabet, id, update
	let wordOrigin = (props.wordOrigin ?? "0"); //1 = article, 0 = defined
		
	const [wordData, setWordData] = useState([]);	
	const [inputValue, setInputValue] = useState({});
  const [timer, setTimer] = useState(null);

	const [totalCnt, setTotalCnt] = useState(0);

	const [targetAndLevelData, setTargetAndLevelData] = useState(targetAndLevelDefaultData);

	const [isFetchingData, setIsFetchingData] = useState(false);
	
  useEffect(() => {
    clearTimeout(timer);
    // Start a new timer after 10 seconds of inactivity
		
    if (Object.keys(inputValue).length > 0) {
      const newTimer = setTimeout(() => {
				updateData();
      }, 3000);

      setTimer(newTimer);
    }
  }, [inputValue]);
	
	
	const updateData = async () => {
		clearTimeout(timer);
		
		const newArray = Object.values(inputValue);
		for (let w of newArray) {
			if (w.qcType) {
				let obj = {
					wordId : w.wordId,
					id : w.qId,
					question: w.question,
					questionHk: w.questionHk,
					explanation: w.explanation,
					explanationHk: w.explanationHk,
					answer : w.answer,
					answerLpIds:[{id:w.wordId}],
					choice1 : w.option1,
					choice1LpIds:[],
					choice2 : w.option2,
					choice2LpIds:[],
					choice3 : w.option3,
					choice3LpIds:[],
					qcType: w.qcType,
				}
				
				await postData("questionApi/updateOrCreateQuestion", obj, navigate)
			} else {
				if (w.meaning || w.sMeaningHk || w.ipa) {
					let obj = {
						wordId : w.wordId,
						sMeaning : w.sMeaning,
						sMeaningHk : w.sMeaningHk,
						ipa : w.ipa,
						
					}
					
					await postData("wordApi/updateWordV2", obj, navigate)
					await postData("wordApi/updateAudioIpa", obj, navigate)
				}
				
				if (w.exampleJson) {
					let obj = {
						wordId : w.wordId,
						examples : w.exampleJson,						
					}
					await postData("wordApi/updateWordSimpleExamples", obj, navigate)
					
				}
			}
		}
		
		setInputValue({})
	}
	
	const fetchData = async (target, format, page, limit, orderBy, itemId) => {		
		setIsFetchingData(true);
		if (Object.keys(inputValue).length > 0) {
			await updateData();
		}
		
		if (target == 'item' && !itemId) {
			return;
		}
		
		let myParam = {target, format, page, limit, itemId, orderBy, wordOrigin};
		
		setWordData([]);
		
		getData('wordApi/analysis?' + (new URLSearchParams(myParam)).toString(), navigate)
		.then(res => {			

			if (res.data.length == 0 && page > 1) {
				setParamCall({target, format, page:1, limit, itemId});
				fetchData(target, format, 1, limit, orderBy, itemId);
			} else {
				setWordData(res.data);
				
				let cnt = res.cnt;
				setTotalCnt(res.cnt);
				
				
				setTargetAndLevelData(targetAndLevelData.map(i => {
					if (i.searchKey == target) {
						return { ...i, count: cnt };
					}
					return i;
				}));
				
				setIsFetchingData(false);
			}
		});
		setTarget(target);
		setFormat(format);
		setPage(page);
		setLimit(limit);
		setOrderBy(orderBy);
		
		setGeneralStorage('wordAnalysisTarget', target);
		setGeneralStorage('wordAnalysisFormat', format);
	}
	
	const searchByItem = () => {		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (itemId == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		if ((target == 'item' || target == 'word') && itemId) {			
			fetchData(target, format, page, limit, orderBy, itemId);
		}
	}
	
	const chooseTargetAndLevel = (target) => {
		setTarget(target);
		setItemId(null);
		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseFormat = (format) => {
		setFormat(format);
		setGeneralStorage('wordListFormat', format);
		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const choosePage = (page) => {	
		setPage(page);
		setGeneralStorage('wordListPage', page);
		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseOrderBy = (orderBy) => {	
		setOrderBy(orderBy);
		setGeneralStorage('wordListOrderBy', orderBy);
		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseLimit = (limit) => {	
		setLimit(limit);
		setGeneralStorage('wordListLimit', limit);
		
		setParamCall({target, format, page, limit, itemId, orderBy});
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	useEffect(() => {		
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
				
		fetchData(target, format, page, limit, orderBy, itemId);
	}, []);

	const createWordQtn = async (wordId, word) => {
		console.log(wordId);
		let qcType = (format == 'qmeaning') ? 49 : 50;
				
		let obj = {
			wordId,
			qcType,
			question: 'What does the word "' + word + '" mean?',
			questionHk: 'What does the word "' + word + '" mean?',
			explanation: "",
			explanationHk: "",
			answer : "",
			answerLpIds:[{id:wordId}],
			choice1 : "",
			choice1LpIds:[],
			choice2 : "",
			choice2LpIds:[],
			choice3 : "",
			choice3LpIds:[],
		}
		
		let res = await postData("questionApi/updateOrCreateQuestion", obj, navigate)
		
		for (let w of wordData) {
			if (w.wordId == wordId) {
				w.qcType = qcType;
				w.question = 'What does the word "' + word + '" mean?';
				w.questionHk = 'What does the word "' + word + '" mean?';
				w.explanation = "";
				w.explanationHk = "";
				w.answer = "";
				w.option1 = "";
				w.option2 = "";
				w.option3 = "";
				w.qId = res.data;
				w.username = "ME";
				w.updateTs = Date.now();
				
				setWordData([...wordData])
				break;
			}
			
		}
		
		
	}

	return (<div style={{display:"flex", flexDirection:"column", color:"#4b3f1b"}}>
		{
			(Object.keys(inputValue).length > 0) && (<div className={s.pendingMsgHolder} >
				<img className={s.pendingMsg} src={uploadPng} />Uploading...
			</div>)
		}
		<div className={s.paramHolder}>
			{
				(target != 'item' && target != 'word' ) && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}>
							<span style={{cursor:"pointer"}} onClick={()=>{
								setTarget('item')
								chooseTargetAndLevel('item')
							}}>Target & level</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.paramSectionHolder}>
						{
							targetAndLevelData.map(
								(d, indexD) => (<>
									<div key={'tAndL-'+indexD} className={s.clickableOption}
										style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
										onClick={() => {
											if (d.searchKey != target) {
												chooseTargetAndLevel(d.searchKey)
											}
										}}
									>{d.title} 
										{(d.count != null) && (<span className={s.targetCnt}> {d.count}</span>)}
									</div>
									{(indexD != targetAndLevelData.length-1) &&(<span>•</span>)}
								</>)
							)
						}
					</div>
				</div>)
			}
			{
				(target == 'item' && showItemSearch) && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}
							
						><span style={{cursor:"pointer"}} onClick={()=>{
							setTarget("word")
							chooseTargetAndLevel('word')
						}}>Item</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.itemHolder}>
						<input value={itemId} type="number" onChange={(e)=>{
							setItemId(e.target.value);
						}} onKeyDown={(event) => {
								if (event.key === 'Enter') {
									searchByItem()
								}
							}}/>
						<div className={(itemId > 0) ? s.btnActive : s.btnInactive}
							onClick={searchByItem}
							>search</div>
					</div>
				</div>)
			}
			{
				(target == 'word' && showItemSearch) && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}
							
						><span style={{cursor:"pointer"}} onClick={()=>{
							setTarget("dse-excellence")
							chooseTargetAndLevel('dse-excellence')
						}}>Word</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.itemHolder}>
						<input style={{width:"300px"}} value={itemId} type="text" onChange={(e)=>{
							setItemId(e.target.value);
						}} onKeyDown={(event) => {
								if (event.key === 'Enter') {
									searchByItem()
								}
							}
						} />
						<div className={(itemId) ? s.btnActive : s.btnInactive}
							onClick={searchByItem}
							>search</div>
					</div>
				</div>)
			}
			
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Analysis</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
			
				<div className={s.paramSectionHolder}>
					{
						formatData.map(
							(d, indexD) => (<>
								<div key={'format-'+indexD} className={s.clickableOption}
									style={(format == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != format) {
											chooseFormat(d.searchKey)
										}
									}}
									>{d.title}</div>
									{(indexD != formatData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
			
				</div>
			</div>
			
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Order By</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
			
				<div className={s.paramSectionHolder}>
					<div className={s.clickableOption} style={(orderBy == "alphabet") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "alphabet") { chooseOrderBy("alphabet") } }}>alphabet</div>
					<span>•</span>
					<div className={s.clickableOption} style={(orderBy == "id") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "id") { chooseOrderBy("id") } }}>id</div>
					<span>•</span>
					<div className={s.clickableOption} style={(orderBy == "update") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "update") { chooseOrderBy("update") } }}>update</div>
					
				</div>
			</div>
			
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Page
						<span className={s.limitSpan}
							onClick={
								()=> {
									if (limit == 10) {
										setLimit(50);
										chooseLimit(50);
									} else if (limit == 50) {
										setLimit(100);
										chooseLimit(100);
									} else if (limit == 100) {
										setLimit(500);
										chooseLimit(500);
									} else {
										setLimit(10);
										chooseLimit(10);
									}
								}
							}
						>{limit}</span>
						</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder} >
					<PagePanel totalCnt={totalCnt} page={page} choosePage={choosePage} limit={limit}/>
				</div>
			</div>
			
		</div>
		<div>
		{
			(format == 'qmeaning' || format == 'qmeaninghk') && 
			(<FormatMeaningQtn format={format} data={wordData} setData={setWordData} inputValue={inputValue} setInputValue={setInputValue} createWordQtn={createWordQtn} isFetchingData={isFetchingData}/>)
		}
		{
			(format == 'wordbasic') &&
			(<FormatBasic itemId={itemId} format={format} data={wordData} setData={setWordData} inputValue={inputValue} setInputValue={setInputValue} isFetchingData={isFetchingData}/>)
		}
		
		</div>
		
	</div>);
}



const targetAndLevelDefaultData = [
	{ title: 'DSE Excellence', searchKey: 'dse-excellence', availableFormat:[] },
	{ title: 'DSE Survival (Words in Questions)', searchKey: 'dse-survival-words-in-questions', availableFormat:[] },
	{ title: 'DSE Survival (Stance/tone/attitude)', searchKey: 'dse-survival-Stance-tone-attitude', availableFormat:[] },
	{ title: 'DSE Survival (Literary devices)', searchKey: 'dse-survival-literary-devices', availableFormat:[] },
	{ title: 'DSE Survival (General)', searchKey: 'dse-survival-general', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv1)', searchKey: 'pre-dse-foundation-lv1', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv2)', searchKey: 'pre-dse-foundation-lv2', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv3)', searchKey: 'pre-dse-foundation-lv3', availableFormat:[] }
	
]

const formatData = [
	{ title: 'Basic Data', searchKey: 'wordbasic'},
	{ title: 'Qtn meaning', searchKey: 'qmeaning'},
	{ title: 'Qtn HK meaning', searchKey: 'qmeaninghk'},	
]